import { api } from "./api";

// The announcements are asked for once and shared: the corner pop-ups and the bell both use them.
let cache = null;

export function loadAnnouncements(force = false) {
  const now = Date.now();
  if (force || !cache || now - cache.at > 60_000) {
    cache = {
      at: now,
      promise: api.get("/announcements").then((r) => (Array.isArray(r.data) ? r.data : [])).catch(() => []),
    };
  }
  return cache.promise;
}
